import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Breadcrumb } from 'components';
import { Tabs, Tab } from '@material-ui/core';
import { getSingleGiftCodeSuccess } from 'redux/actions/gift_card';
import { useDispatch } from 'react-redux';
import { useStyles } from '../styles';
import GiftHistoryTable from '../giftHistory/GiftHistoryTable';
import GiftCodeInfoForm from './GiftCodeForm';


const CreateGiftCode = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState('giftCodeForm');

  useEffect(() => {
    return () => {
      dispatch(getSingleGiftCodeSuccess(null));
    };
  }, []);

  const locationState = history.location.state as LocationState;
  const breadcrumbPath = locationState && locationState.params ? `/gift-cards${locationState.params}` : '/gift-cards';

  return (
    <div className="flex-grow flex-column relative h-full scroll-y pb-5">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Gift Cards', path: breadcrumbPath},
            { name: 'Edit Gift Code'}
          ]}
        />
      </div>
      <div className={`${classes.card} px-5`}>
        <div className={'flex justify-between w-full'}>
          <Tabs
            value={tabValue}
            onChange={(e, newValue) => setTabValue(newValue)}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab
              label="Edit Gift Code"
              value="giftCodeForm"
              className="font-semibold"
            />
            <Tab
              label="History"
              value="giftHistory"
              className="font-semibold"
            />
          </Tabs>
        </div>
        {tabValue === 'giftCodeForm' && <GiftCodeInfoForm breadcrumbPath={breadcrumbPath} />}
        {tabValue === 'giftHistory' && <GiftHistoryTable />}
      </div>
    </div>
  );
};

export default CreateGiftCode;
